import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import { RCard, RCardBody, RCardFooter } from '@components/card'
import { RForm, RFormInput } from '@components/form'
import { RButtonLoading } from '@components/button'
import { RAnchorSecondary } from '@components/anchor'
import { formValidation } from '@hooks/validation'
import { errorResponse, successResponse } from '@hooks/response'
import ResourceService from '@services/resource.service'

const UbahPassword = () => {
    let history = useHistory();

    const [submit, setSubmit] = useState(false);
    const [invalid, setInvalid] = useState({});

    const [passwordLama, setPasswordLama] = useState({
        id: 'password_lama',
        type: 'password',
        label: 'Password Lama',
        required: true,
        placeholder: 'Password Lama'
    });

    const [passwordBaru, setPasswordBaru] = useState({
        id: 'password_baru',
        type: 'password',
        label: 'Password Baru',
        required: true,
        placeholder: 'Password Baru'
    });

    const [passwordBaruUlangi, setPasswordBaruUlangi] = useState({
        id: 'password_baru_ulangi',
        type: 'password',
        label: 'Ulangi Password Baru',
        required: true,
        placeholder: 'Ulangi Password Baru'
    });

    const handleSubmitForm = async (event) => {
        event.preventDefault()

        const el = {
            passwordLama,
            passwordBaru,
            passwordBaruUlangi
        }

        if (!submit) {
            formValidation(el)
            .then((res) => {
                let success = false

                setSubmit(true)
                setInvalid({})

                ResourceService.put('/ubah-password', res)
                .then(
                    (res) => {
                        setPasswordLama({
                            ...passwordLama,
                            value: ''
                        })
                        setPasswordBaru({
                            ...passwordBaru,
                            value: ''
                        })
                        setPasswordBaruUlangi({
                            ...passwordBaruUlangi,
                            value: ''
                        })
                        successResponse(res)
                        success = true
                    },
                    (error) => errorResponse(error, setInvalid)
                )
                .finally(() => {
                    setSubmit(false)
                    if (success) {
                        history.push('/account-profile')
                    }
                })
            })
            .catch((err) => setInvalid(err))
        }
    }

    return (
        <RCard>
            <RForm onSubmit={handleSubmitForm}>
                <RCardBody>
                    <div className="mb-2">
                        <RFormInput value={passwordLama} setValue={setPasswordLama} invalid={invalid} />
                    </div>

                    <div className="mb-2">
                        <RFormInput value={passwordBaru} setValue={setPasswordBaru} invalid={invalid} />
                    </div>

                    <div className="mb-2">
                        <RFormInput value={passwordBaruUlangi} setValue={setPasswordBaruUlangi} invalid={invalid} />
                    </div>
                </RCardBody>

                <RCardFooter>
                    <div className='d-flex justify-content-center'>
                        <RAnchorSecondary href='/account-profile'>Kembali</RAnchorSecondary>
                        &nbsp;
                        <RButtonLoading type='submit' loading={submit}>Simpan</RButtonLoading>
                    </div>
                </RCardFooter>
            </RForm>
        </RCard>
    )
}

export default UbahPassword
